import {buildfilterOptions} from "$lib/scala.js";

export let filterOptions = {}

export function initFilterOptions (allWords) {
    filterOptions =  buildfilterOptions(allWords)
}


